import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { TRABADJU_INFO as T } from '@/utils/businessInfo';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function Privacidade() {
  const { t } = useTranslation();
  const today = new Date().toLocaleDateString('pt-PT');
  return (
    <div className="min-h-screen bg-gray-50 py-10" data-testid="page-privacidade">
      <div className="max-w-3xl mx-auto px-4">
        <Link to="/"><Button variant="ghost" className="mb-4"><ArrowLeft className="h-4 w-4 mr-2" />{t('legal.back')}</Button></Link>
        <article className="bg-white rounded-xl shadow-sm p-8 prose prose-slate max-w-none">
          <h1 className="text-3xl font-bold mb-2">{t('legal.privacyTitle')}</h1>
          <p className="text-sm text-gray-500 mb-2">{t('legal.lastUpdated', { date: today })}</p>
          <p className="text-xs text-gray-400 mb-6 not-italic">{t('legal.ptOnlyNotice')}</p>

          <h2>1. Responsável pelo Tratamento</h2>
          <p>O responsável pelo tratamento dos dados pessoais recolhidos no <strong>{T.brand}</strong> ({T.website}) é:</p>
          <ul>
            <li><strong>{T.legal_name}</strong></li>
            <li>NIF: {T.nif}</li>
            <li>Sede: {T.address}</li>
            <li>Contacto DPO: <a href={`mailto:${T.email_legal}`}>{T.email_legal}</a></li>
          </ul>

          <h2>2. Dados Recolhidos</h2>
          <p>Recolhemos apenas os dados estritamente necessários para a prestação do serviço:</p>
          <ul>
            <li><strong>Candidatos:</strong> nome, email, telefone (opcional), localização, CV, experiência profissional, candidaturas submetidas.</li>
            <li><strong>Empregadores:</strong> nome da empresa, NIF (opcional), email, telefone, localização, anúncios publicados, histórico de compras.</li>
            <li><strong>Pagamentos:</strong> número de factura, montante, método de pagamento. <em>Não armazenamos dados de cartão</em> — os pagamentos com cartão são processados directamente pela SISP / vinti4.</li>
            <li><strong>Técnicos:</strong> endereço IP, tipo de browser, data/hora de acesso (logs de segurança).</li>
          </ul>

          <h2>3. Finalidades</h2>
          <ul>
            <li>Criar e gerir a conta do utilizador;</li>
            <li>Permitir candidaturas a vagas e gestão de processos de selecção pelos empregadores;</li>
            <li>Processar pagamentos e emitir facturas;</li>
            <li>Enviar comunicações operacionais (confirmação de compra, nova candidatura, recuperação de senha);</li>
            <li>Cumprir obrigações legais e fiscais;</li>
            <li>Prevenir fraudes e garantir a segurança da plataforma.</li>
          </ul>

          <h2>4. Base Legal</h2>
          <ul>
            <li><strong>Execução de contrato</strong> — para prestar o serviço solicitado.</li>
            <li><strong>Obrigação legal</strong> — para emissão de facturas e cumprimento fiscal.</li>
            <li><strong>Consentimento</strong> — para comunicações de marketing (opcionais).</li>
            <li><strong>Interesse legítimo</strong> — para segurança e prevenção de fraude.</li>
          </ul>

          <h2>5. Partilha com Terceiros</h2>
          <p>Os dados pessoais só são partilhados com terceiros estritamente necessários:</p>
          <ul>
            <li><strong>SISP / vinti4</strong> — processamento de pagamentos com cartão;</li>
            <li><strong>Resend</strong> — envio de emails transaccionais;</li>
            <li><strong>Empregador</strong> — recebe os dados de contacto e CV do candidato apenas quando este se candidata a uma vaga;</li>
            <li><strong>Autoridades</strong> — quando exigido por lei.</li>
          </ul>
          <p>Não vendemos nem alugamos dados pessoais a terceiros.</p>

          <h2>6. Conservação</h2>
          <ul>
            <li>Conta activa: enquanto o utilizador mantiver a conta;</li>
            <li>Conta inactiva: até 24 meses após a última actividade, depois eliminada;</li>
            <li>Dados fiscais (facturas): 10 anos por obrigação legal cabo-verdiana.</li>
          </ul>

          <h2>7. Direitos do Titular</h2>
          <p>O utilizador tem direito a:</p>
          <ul>
            <li>Aceder, rectificar ou eliminar os seus dados;</li>
            <li>Solicitar a portabilidade dos dados;</li>
            <li>Opor-se ao tratamento ou retirar o consentimento;</li>
            <li>Apresentar reclamação à autoridade de protecção de dados (CNPD-CV).</li>
          </ul>
          <p>Para exercer estes direitos, contactar <a href={`mailto:${T.email_legal}`}>{T.email_legal}</a>.</p>

          <h2>8. Segurança</h2>
          <p>Implementamos medidas técnicas e organizativas adequadas: senhas com hash bcrypt, conexões HTTPS/TLS, separação de ambientes, controlo de acesso e backups regulares.</p>

          <h2>9. Cookies</h2>
          <p>Utilizamos cookies e tokens de autenticação. Consulte a nossa <Link to="/cookies">Política de Cookies</Link> para detalhes.</p>

          <h2>10. Alterações</h2>
          <p>Esta política pode ser alterada. As alterações materiais serão comunicadas por email aos utilizadores registados.</p>

          <h2>11. Contacto</h2>
          <p>Dúvidas sobre privacidade: <a href={`mailto:${T.email_legal}`}>{T.email_legal}</a></p>
        </article>
      </div>
    </div>
  );
}
